import React, { useContext, useState, useEffect } from 'react'
import { selectData } from 'layouts/onboarding'
import ValuePoint from 'admin/components/ValuePoint'

import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import ClientTSPAllocation from 'admin/components/ClientTSPAllocation'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

function TSPAllocation({
  collapseSections,
  toggleCollapse,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const [localForm, setLocalForm] = useState({
    tspBalance: intakeState.tspBalance || '',
    tspRothBalance: intakeState.tspRothBalance || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.tspAllocation}
                style={{ width: '100%' }}
              >
                <ValuePoint text="Strategy - Why these funds?" />
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="tspAllocation"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('tspAllocation')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                TSP Allocation
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.tspAllocation
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse
            in={collapseSections.tspAllocation}
            style={{ width: '100%' }}
          >
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12}>
                <Typography variant="h5">Fund Allocation</Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <ClientTSPAllocation
                  intakeState={intakeState}
                  updateIntakeStateAndSubmit={updateIntakeStateAndSubmit}
                  updateIntakeStateAtKey={updateIntakeStateAtKey}
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'riskTolerance',
                  label: 'Risk Tolerance',
                  placeholder: 'Risk Tolerance',
                  inputType: 'select',
                  value: intakeState.riskTolerance,
                  onChange: updateIntakeStateAndSubmit((riskTolerance) =>
                    updateIntakeStateAtKey({ riskTolerance })
                  ),
                  options: selectData.riskTolerance,
                })}
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default TSPAllocation
